/** Competência canônica do SGC: `NomeDoMês/AAAA` (ex.: Julho/2026). */

export const MESES_COMPETENCIA = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

const MES_POR_NUM = {
  '01': 'Janeiro',
  '1': 'Janeiro',
  '02': 'Fevereiro',
  '2': 'Fevereiro',
  '03': 'Março',
  '3': 'Março',
  '04': 'Abril',
  '4': 'Abril',
  '05': 'Maio',
  '5': 'Maio',
  '06': 'Junho',
  '6': 'Junho',
  '07': 'Julho',
  '7': 'Julho',
  '08': 'Agosto',
  '8': 'Agosto',
  '09': 'Setembro',
  '9': 'Setembro',
  '10': 'Outubro',
  '11': 'Novembro',
  '12': 'Dezembro',
};

function normKey(s) {
  return String(s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

/**
 * Converte competência para o padrão `Janeiro/2026`.
 * Aceita: `07/2026`, `7/2026`, `Julho/2026`, `julho/2026`.
 * @returns {string|null}
 */
export function normalizarCompetencia(valor) {
  const raw = String(valor || '').trim();
  if (!raw) return null;
  const parts = raw.split('/');
  if (parts.length < 2) return null;
  const mesPart = parts[0].trim();
  const anoPart = parts[parts.length - 1].trim();
  if (!/^\d{4}$/.test(anoPart)) return null;

  let mesNome = MES_POR_NUM[mesPart] || MES_POR_NUM[String(parseInt(mesPart, 10))];
  if (!mesNome) {
    const idx = MESES_COMPETENCIA.findIndex((m) => normKey(m) === normKey(mesPart));
    if (idx >= 0) mesNome = MESES_COMPETENCIA[idx];
    else {
      const idx3 = MESES_COMPETENCIA.findIndex((m) =>
        normKey(m).startsWith(normKey(mesPart).slice(0, 3))
      );
      if (idx3 >= 0) mesNome = MESES_COMPETENCIA[idx3];
    }
  }
  if (!mesNome) return null;
  return `${mesNome}/${anoPart}`;
}

export function extrairAnoCompetencia(valor) {
  const n = normalizarCompetencia(valor) || String(valor || '');
  const m = n.match(/\/(\d{4})$/);
  return m ? m[1] : null;
}

export function extrairMesIndexCompetencia(valor) {
  const n = normalizarCompetencia(valor);
  if (!n) return null;
  const mes = n.split('/')[0];
  const idx = MESES_COMPETENCIA.findIndex((m) => normKey(m) === normKey(mes));
  return idx >= 0 ? idx + 1 : null;
}

export function montarCompetencia(mesNomeOuNum, ano) {
  const raw = `${mesNomeOuNum}/${ano}`;
  return normalizarCompetencia(raw);
}
